import { useEffect, useState } from "react";
import { getWeatherData } from "../utils";
import bgImage from "assets/background.png";
import Login from "components/user/Login";

const PageUser = ({ userInfo, setUserInfo, setIsLoading }) => {
  const [weather, setWeather] = useState(null);
  useEffect(() => {
    if (!userInfo?.remoteUrl) return;
    const fetchWeather = async () => {
      const weather = await getWeatherData(userInfo.remoteUrl);
      if (weather?.city) {
        setWeather(weather);
      }
    };

    fetchWeather();
  }, [userInfo]);

  return (
    <div
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "right center",
        backgroundSize: "auto 100%",
        backgroundColor: "#fdf1d0",
        padding: "1.5rem",
        paddingTop: "0",
        borderRadius: "1.5rem",
        marginBottom: "2rem",
        boxShadow: "0 4px 10px rgba(0,0,0,0.06)",
        position: "relative",
      }}
    >
      <Login
        userInfo={userInfo}
        setUserInfo={setUserInfo}
        setIsLoading={setIsLoading}
      />
      <h2 style={{ fontSize: "1.5rem", fontWeight: "bold", color: "#b45309" }}>
        Hello, {userInfo ? userInfo.email.split("@")[0] : "User"}!
      </h2>
      <p style={{ color: "#92400e", marginBottom: "0" }}>
        Welcome {userInfo ? userInfo.homeyName : "Home"}!
      </p>
      {userInfo && (
        <div
          style={{
            color: "#92400e80",
            marginBottom: "0.75rem",
            fontSize: "0.75rem",
          }}
        >
          ({userInfo.homeyId})
        </div>
      )}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "0.25rem",
          fontSize: "0.95rem",
          color: "#78350f",
        }}
      >
        {weather ? (
          <>
            <div>{`🌡️ ${weather.temperature}°C Outdoor temperature`}</div>
            <div>{`${weather.state}`}</div>
          </>
        ) : (
          <div>🌤️ Loading weather...</div>
        )}
      </div>
    </div>
  );
};

export default PageUser;
